var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticClass:"content",attrs:{"xs12":"","sm10":"","md9":"","lg7":"","xl5":""}},[(_vm.appLoaded)?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }